// eslint-disable-next-line import/prefer-default-export
export const FILEVIEW_RIGHT_COLUMN = {
  HIDE: "HIDDEN",
  SHOW_NEWS: "SHOW_NEWS",
  SHOW_MESSAGES: "SHOW_MESSAGES",
};
